import { ReactComponent as IconDongLuong } from '../../../assets/images/InvestmentPortfolio/icon-dong-luong.svg'
import { ReactComponent as IconDsc } from '../../../assets/images/InvestmentPortfolio/icon-dsc.svg'
import { ReactComponent as IconGiatri } from '../../../assets/images/InvestmentPortfolio/icon-gia-tri.svg'
import { ReactComponent as IconTangTruong } from '../../../assets/images/InvestmentPortfolio/icon-tang-truong.svg'
import iconChart from '../../../assets/images/InvestmentPortfolio/icon-chart.png'
import iconChart2 from '../../../assets/images/InvestmentPortfolio/icon-chart.svg'
import iconComment from '../../../assets/images/InvestmentPortfolio/icon-comment.svg'
import iconSearch from '../../../assets/images/InvestmentPortfolio/icon-search.svg'
import iconPlus2 from '../../../assets/images/InvestmentPortfolio/icon-plus.svg'
import './TableList.scss'
import SortData from './TabelList/SortData'
import { setShowBaocao } from 'store/actionReducers/InvestmentPortfolioStore';
import { useDispatch } from 'react-redux'
import { compareValue, formatMoney } from 'Helpers/helpFunction'
import {
  changeInputSearchStock,
  changeTabActive,
  changeTabActiveMobileV2
} from 'store/actionReducers/StocksAnalysisStore'
import { Popover } from 'antd'
import EmptyData2 from 'components/common/EmptyData2'
import { changeMenu } from 'store/actionReducers/MenuStore'
import { useHistory } from 'react-router-dom'

export default function TableList(props: any) {
  const history = useHistory();
  const data = props?.data
  const showRemove = props?.showRemove
  const showAdd = props?.showAdd
  const dispatch = useDispatch();

  const handleScroll = (e: any) => {
    console.log(e, 'e');
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    console.log(bottom, 'bottom ');

    if (bottom) {
      if (props.LoadMoreData) {
        props.LoadMoreData()
      }
    }
  }

  const handleChangePageMobile = (tabActive: string, type: any) => {
    const url = '/stock-analysis'
    dispatch(changeMenu({ urlActive: url }))
    if (type === 1) {
      dispatch(changeTabActiveMobileV2({ tabActiveMobile: tabActive }))
    } else if (type === 2) {
      dispatch(changeTabActive({ tabActive: tabActive }))
    }
    history.push(url);
  }

  return (
    <>
      <div className="yjiejzxqyc">
        <div className="huuasqxchl">Mã</div>
        <div className="huuasqxchl plzqqsseut">Giá đóng cửa</div>
        <div className="huuasqxchl">Ngành</div>
        <div className="huuasqxchl"><IconTangTruong /></div>
        <div className="huuasqxchl"><IconGiatri /></div>
        <div className="huuasqxchl"><IconDongLuong /></div>
        <div className="huuasqxchl"><IconDsc /></div>
        <div className="huuasqxchl G6RkbETCek"></div>
        <div className="huuasqxchl JIVa2WSNTJ">
          <SortData />
        </div>
      </div>
      <div className='vkfyxnmhgo' onScroll={(event) => handleScroll(event)}>
        {
          data && data.length > 0 ? data.map((item: any, key: number) => {
            const closePrice: string = parseFloat(item?.closePrice).toString()

            return (
              <div className='adbipzymqz' key={key} onClick={() => dispatch(changeInputSearchStock({ value: item?.ticker, loading: true }))}>
                <div className='glsoccgggu xwsqjeawzy'>{item?.ticker}</div>
                <div className='glsoccgggu rldciqfsjf mrjxooynnx'>{formatMoney(closePrice, 2)}</div>
                <div className='glsoccgggu rldciqfsjf'>{item?.icbNamePath}</div>
                <div className='glsoccgggu' style={{ color: compareValue(item?.growthRanking) }}>{item?.growthRanking}</div>
                <div className='glsoccgggu' style={{ color: compareValue(item?.valueRanking) }}>{item?.valueRanking}</div>
                <div className='glsoccgggu' style={{ color: compareValue(item?.momentumRanking) }}>{item?.momentumRanking}</div>
                <div className='glsoccgggu' style={{ color: compareValue(item?.dscRatingRanking) }}>{item?.dscRatingRanking}</div>
                <div className='glsoccgggu BTUCvsGeNH G6RkbETCek IiDhenEZoz'>
                  <div className='zuhnymirie'>
                    {/* {
                      showAdd ? <div className='gnwljwcbfj'>
                        <IconPlus className='wshelwiufv' />
                      </div> : null
                    }
                    {
                      showRemove ? <div className='gnwljwcbfj'>
                        <IconPlus className='StO69jQNSZ' />
                      </div> : null
                    } */}
                    <div className='gnwljwcbfj' onClick={() => {
                      // dispatch(changeInputSearchStock({ value: item?.ticker, loading: true }))
                      dispatch(setShowBaocao(true))
                    }
                    }><img src={iconChart} alt="" className='timzhybllj' /></div>
                  </div>
                </div>
                <div className='glsoccgggu G6RkbETCek'>
                  <Popover placement="bottom" title={''} content={'Tính năng sắp ra mắt'} trigger="hover">
                    <button className='sbgkgetbtc'>Đặt Lệnh</button>
                  </Popover>
                </div>
                <div className='wxtaOhKc0s'>
                  <div className='GD7IE68doj'>
                    <div className='OXzvxWRr9f' onClick={() => handleChangePageMobile('tang-truong', 1)}><img className='KZGDinkvXk' alt='' src={iconChart2} /></div>
                    <div className='OXzvxWRr9f' onClick={() => handleChangePageMobile('bao-cao', 2)}><img className='KZGDinkvXk' alt='' src={iconComment} /></div>
                    <div className='OXzvxWRr9f' onClick={() => handleChangePageMobile('dong-luong', 1)}><img className='KZGDinkvXk' alt='' src={iconSearch} /></div>
                  </div>
                  <div className='bbiL3JlHne'>
                    <Popover placement="bottom" title={''} content={'Tính năng sắp ra mắt'} trigger="hover">
                      <button className='sbgkgetbtc'>Đặt Lệnh</button>
                    </Popover>
                  </div>
                  <div className='G80T625Lkx'>
                    <img className='mNTPSzC1F3' alt='' src={iconPlus2} />
                  </div>
                </div>
              </div>
            )
          }) : <div>
            <EmptyData2 />
          </div>
        }
      </div>
    </>
  )
}